import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-home-video',
  templateUrl: './home-video.component.html',
  styleUrls: ['./home-video.component.scss']
})
export class HomeVideoComponent implements OnInit {
  @ViewChild('vimeoVideo') videoPlayer!: ElementRef;
  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // Get the Bootstrap modal element
    const modalElement = document.getElementById('staticBackdrop');

    if (modalElement) {
      // Listen for modal close event and pause the video
      modalElement.addEventListener('hidden.bs.modal', () => {
        this.onCloseModal();
      });
    }
  }

  onCloseModal(): void {
    if (this.videoPlayer) {
      const iframe = this.videoPlayer.nativeElement as HTMLIFrameElement;
      const videoSrc = iframe.src; // Store the current video source
      iframe.src = ''; // Clear the source to stop the video
      setTimeout(() => {
        iframe.src = videoSrc; // Restore the source after a brief delay
      }, 100); // Small delay ensures the video stops completely
    }
  }
}
